import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { MESSAGE, ROUTE } from '../../config'
import { isArticle, isVideo } from '../../extras/utils'
import ContentList from '../../components/ContentList'
import BrowseGuideLayout from '../../components/BrowseGuideLayout'
import Icon from '../../components/Icon'

export const BRAND_SPECIFIC_TAG = 'Brand Specific Information'

const isBrandSpecificContent = item => item.tags && item.tags.includes(BRAND_SPECIFIC_TAG)

export const filteredContents = contents => {
  const publications = contents?.publications
  const publiations = publications
    ? (typeof publications.toJS === 'function' ? publications.toJS() : publications)
    : []

  const videos = contents?.videos
    ? (typeof contents.videos.toJS === 'function' ? contents.videos.toJS() : contents.videos)
    : []

  const brandSpecificContents = [...publiations, ...videos].filter(isBrandSpecificContent)
  const filteredPubs = publiations.filter(contentItem => !isBrandSpecificContent(contentItem))
  const filteredVideos = videos.filter(contentItem => !isBrandSpecificContent(contentItem))

  return {
    ...contents,
    publications: filteredPubs,
    videos: filteredVideos,
    brandSpecificContents: brandSpecificContents,
  }
}

const BrandSpecificInformation = ({ baseRoute, contents, match }) => {
  const linkedContent = useMemo(() => {
    return contents.map(item => {
      const contentTypeRoute = isArticle(item) ? ROUTE.ARTICLES : isVideo(item) ? ROUTE.VIDEOS : '/publication'

      return {
        ...item,
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.BRAND_SPECIFIC}${contentTypeRoute}/${item.resourceKey}`,
        icon: isVideo(item) ? <Icon type='video' /> : <Icon type='list-topic' />,
      }
    })
  }, [contents, baseRoute])

  return (
    <BrowseGuideLayout match={match} baseRoute={baseRoute}>
      {linkedContent.length ? (
        <ContentList variant='browse-guide' topics={linkedContent} emptyText={MESSAGE.EMPTY_TOPICS} baseRoute={match.url} />
      ) : null}
    </BrowseGuideLayout>
  )
}

BrandSpecificInformation.propTypes = {
  contents: PropTypes.array,
  match: PropTypes.object,
  baseRoute: PropTypes.string,
}

function mapStateToProps({ contents }) {
  const processedContents = filteredContents(contents)

  return {
    contents: processedContents.brandSpecificContents,
  }
}

export default connect(mapStateToProps)(BrandSpecificInformation)
